import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Loading fallback component for React Suspense
 * Displayed while lazy-loaded route components are being fetched
 */
const LoadingFallback: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <Loader2 className="w-12 h-12 text-blue-600 animate-spin" />
        </div>
        <p className="text-gray-600 text-lg font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingFallback;
